import { authLayoutRoute } from "@/routes/__root";
import { ROUTERS } from "@/shared/constants/router";
import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
const SignIn = lazyRouteComponent(() => import("@pages/Auth/sign-in"));

export const signInRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: ROUTERS.SIGN_IN,
  component: SignIn,
  validateSearch: (search: { token?: string; redirect?: string }) => search,
});
